// ! This file was auto-generated from the everest OpenAPI schema. Do not override this file.
import { Tags } from "./tags.autogen";
export const endpoints = {
    addIntakeForm: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.intake_forms, id: "LIST" }]
    },
    addTicket: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.tickets, id: "LIST" }]
    },
    addWorkflow: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.workflows, id: "LIST" }]
    },
    backToReview: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.tickets, id: arg.ticketId }, { type: Tags.tickets, id: "LIST" }]
    },
    createRouting: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.routing, id: "LIST" }]
    },
    createTicketPackage: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.packages, id: "LIST" }]
    },
    createVersion: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.versions, id: arg.documentId }, { type: Tags.versions, id: "LIST" }]
    },
    createVersionBackup: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.version_backup, id: arg.documentId }, { type: Tags.version_backup, id: "LIST" }]
    },
    deleteRouting: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.routing, id: arg.routingId }, { type: Tags.routing, id: "LIST" }]
    },
    deleteTicket: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.tickets, id: arg.ticketId }, { type: Tags.tickets, id: "LIST" }]
    },
    deleteVersion: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.versions, id: arg.versionId }, { type: Tags.versions, id: "LIST" }]
    },
    deleteWorkflow: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.workflows, id: arg.workflowId }, { type: Tags.workflows, id: "LIST" }]
    },
    downloadVersion: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.versions, id: arg.versionId }]
    },
    getActivationStatus: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.routing_configuration, id: "LIST" }]
    },
    getAllVersions: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.versions, id: arg.documentId }]
    },
    getAllWorkflows: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.workflows, id: "LIST" }]
    },
    getDocumentDetails: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.tickets, id: arg.ticketId }]
    },
    getInitialSigners: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.packages, id: "LIST" }]
    },
    getPermissionsAccesibility: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.permissions, id: "LIST" }]
    },
    getRoutingById: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.routing, id: arg.routingId }]
    },
    getRoutingConfiguration: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.routing_configuration, id: "LIST" }]
    },
    getTicket: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.tickets, id: arg.ticketId }]
    },
    getTicketCurrentStageDetails: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.tickets, id: arg.ticketId }]
    },
    getTicketIntakeForm: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.tickets, id: arg.ticketId }]
    },
    getTicketPackageActivities: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.packages, id: "LIST" }]
    },
    getTicketPackageRecipients: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.packages, id: "LIST" }]
    },
    getTicketSummary: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.tickets, id: arg.ticketId }]
    },
    getUnroutedWorkflows: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.routing, id: "LIST" }]
    },
    getVersion: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.versions, id: arg.versionId }]
    },
    getWorkflow: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.workflows, id: arg.workflowId }]
    },
    getWorkflowParties: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.turn_tracking_parties, id: arg.workflowId }]
    },
    patchRoutingConfiguration: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.routing_configuration, id: "LIST" }]
    },
    reassignInitialSigner: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.packages, id: "LIST" }]
    },
    remindTicketPackageRecipient: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.packages, id: "LIST" }]
    },
    searchRouting: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.routing, id: "LIST" }]
    },
    signTicketPackage: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.packages, id: "LIST" }]
    },
    ticketComplete: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.tickets, id: arg.ticketId }, { type: Tags.tickets, id: "LIST" }]
    },
    updateDocument: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.documents, id: arg.documentId }, { type: Tags.documents, id: "LIST" }]
    },
    updateRouting: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.routing, id: arg.routingId }, { type: Tags.routing, id: "LIST" }]
    },
    updateTicket: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.tickets, id: arg.ticketId }, { type: Tags.tickets, id: "LIST" }]
    },
    updateTurnTracking: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.turn_tracking, id: arg.ticketId }, { type: Tags.turn_tracking, id: "LIST" }]
    },
    uploadSigned: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.tickets, id: arg.ticketId }, { type: Tags.tickets, id: "LIST" }]
    },
    viewTicketPackage: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.packages, id: "LIST" }]
    }
} as const;
